import { Input, Modal } from "antd";
import ButtonComponent from "../button";
import ItemCounter from "../itemsCounter";
import { useContext, useState } from "react";
import Context from "../../context";
import "./style.scss";

const { TextArea } = Input;

export default function AddToCartPopup({ item, isModalOpen, setIsModalOpen }) {
  const { cartItems, setCartItems, foodMenuData, setFoodMenuData } =
    useContext(Context);
  const [currentCount, setCurrentCount] = useState(1);
  const [specialNotes, setSpecialNotes] = useState("");

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleAddToCart = () => {
    handleCancel();
    let updatedItem = null;
    foodMenuData.forEach((val) => {
      if (val.categoryName === item.categoryName) {
        const dishesArray = val.dishes.map((dish) => {
          return dish.name === item.name
            ? {
                ...dish,
                quantity: currentCount,
              }
            : dish;
        });
        updatedItem = {
          categoryName: val.categoryName,
          dishes: dishesArray,
        };
      }
    });
    if (updatedItem) {
      setFoodMenuData((prevItem) =>
        prevItem.map((foodItem) =>
          foodItem.categoryName === item.categoryName ? updatedItem : foodItem
        )
      );
    }

    setCartItems([
      ...cartItems,
      {
        ...item,
        quantity: currentCount,
        notes: specialNotes,
      },
    ]);
  };

  const handleCartPopupCounter = (action) => {
    if (currentCount === 1 && action === "minus") return;
    setCurrentCount(action === "plus" ? currentCount + 1 : currentCount - 1);
  };
  return (
    <>
      <Modal
        title={item.name}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[]}
        className="addCartPopup"
      >
        <p>{item.description}</p>
        <div className="specialReq">
          <label>Special Request</label>
          <TextArea
            onChange={(e) => {
              setSpecialNotes(e.target.value);
            }}
          />
        </div>
        <ItemCounter
          currentCount={currentCount}
          handleCounter={handleCartPopupCounter}
        />
        <div className="addToCartButton">
          <ButtonComponent
            handleOnclick={handleAddToCart}
            text={"Add to Cart"}
            className={"darkBgCommonBtn"}
          />
        </div>
      </Modal>
    </>
  );
}
